/*
 * @Author: mayanxia 
 * @Date: 2021-01-12 11:51:45 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2021-11-11 10:09:45
 */
<template>
    <div class="index-container">
        <a-spin :spinning="false" style="height: 100%">
            <a-row style="height: 78px" :gutter="3" class="header-row">
                <a-col :span="24" style="height: 100%">
                    <a-row style="height: 100%" :gutter="3" class="header">
                        <a-col :span="9">
                            <div style="height: 100%;" class="header-left">
                                <div class="tabs">
                                    <div class="tab" v-for="item in tabList" :key="item.key" :class="tabKey == item.key?'tab-active': ''" @click="tabKey = item.key">
                                        <label class="tab-title" >{{item.title}}</label>
                                    </div>
                                </div>
                            </div>
                        </a-col>
                        <a-col :span="6" style="height: 100%;text-align: center" class="theme-color theme-font flex-center">智慧水务管理平台</a-col>
                        <a-col :span="9" style="text-align: right">
                            <div style="height: 100%;" class="header-right">
                                <!--<div class="right-time">
                                    <div class="time">{{time}}</div>
                                    <div class="date">{{date}}</div>
                                </div>
                                -->
                                <router-link to="/sysHome">系统首页</router-link>
                            </div>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row style="height: calc(100% - 78px)">
                <a-col style="height: 100%">
                    <div class="index-main" style="height: 100%">
                        <a-row style="height: 100%;positive: relative">
                            <a-col :span="24" style="height: 100%;">
                                <a-row style="height: 100%;">
                                    <a-col :span="24" style="height: 100%;position: relative;">
                                        <div style="position: absolute;top: 0;left: 80px;z-index: 99">
                                            <device-total-top :itemList="itemList"></device-total-top>
                                        </div>
                                        <div style="position: absolute;top: 20px;right: 80px;z-index: 99">
                                            <div style="width: 300px" class="search">
                                                <a-select
                                                    labelInValue
                                                    :allowClear="true"
                                                    show-search
                                                    v-model="keyWord"
                                                    placeholder="请输入关键字进行查询"
                                                    style="width: 200px"
                                                    :default-active-first-option="false"
                                                    option-label-prop="label"
                                                    :show-arrow="false"
                                                    :filter-option="false"
                                                    :not-found-content="null"
                                                    dropdownClassName="keyWordSearh"
                                                    @search="handleSearch"
                                                    @change="handleChange"
                                                >
                                                        <a-select-option v-for="(item,index) in dataSource" :key="item.id" :value="item.id" :label="item.userMeterAddr">
                                                            <div>({{index}})用户名称:{{ item.userName }}</div>
                                                            <div>用户编号:{{ item.userId }}</div>
                                                            <div>安装位置:{{ item.userMeterAddr }}</div>
                                                            <div>表编号:{{ item.meterId }}</div>
                                                        </a-select-option>
                                                </a-select>
                                            </div>
                                        </div>
                                        <!--
                                        <echart-b-map :titleImage="titleImage"></echart-b-map>
                                        -->
                                        <div id="container" tabindex="0" style="width: 100%;height: 100%;position: fixed" ></div>
                                    </a-col>
                                </a-row>
                            </a-col>
                        </a-row>
                    </div>
                </a-col>
            </a-row>
        </a-spin>
    </div>
</template>
<script>

import { formatTime } from "@/utils/util"
import echartBMap from './modules/echartBMap'
import deviceTotalTop from './modules/deviceTotalTop'
import { postAction,getAction } from '@/api/manage'
import AMapLoader from '@amap/amap-jsapi-loader';
import {Mn100FkStatusObj} from '@/utils/constants/protocolConstant'
import { isUndefinedAndNull,isNull,isUndefined } from '@/utils/validate'
var markers = [];

export default {
  components: { echartBMap,deviceTotalTop },
    name: "screen",
    data() {
        return {
            loading: true,
            titleImage:require("@/assets/images/title-gradual.png"),
            tabList: [{title: '一张图', key: 'tabKey1'}],
            tabKey: 'tabKey1',
            time: '',
            date: '',
            url: {
                queryTotalCountByOrgCode: '/jeecg-charge/meter/meterUserinfo/queryTotalCountByOrgCode',
                queryMeterAddrInfoByOrgCode: '/jeecg-charge/meter/meterUserinfo/queryMeterAddrInfoByOrgCode',
                queryMeterInfoByLngAndLat: '/jeecg-charge/meter/meterUserinfo/queryMeterInfoByLngAndLat'
            },
            itemList: [
                {title: '全部',key: 7,icon: ' iconquanbu',num: 0,enName: 'All Device'},
                {title: '水表',key: 6,icon: ' iconshuibiao1',num: 0,enName: 'waterDevice'},
                {title: '压力',key: 1,icon: ' iconyali',num: 0,enName: 'pressDevice'},
                {title: '流量',key: 2,icon: ' iconliuliang',num: 0,enName: 'levelMeasure'},
                {title: '水质',key: 3,icon: ' iconshuizhi1',num: 0,enName: 'waterQuality'},
                {title: 'DMA',key: 4,icon: ' icondma',num: 0,enName: 'DMADevice'},
                {title: '停漏水',key: 5,icon: ' icontingloushui',num: 0,enName: 'leaking'}
            ],
            map: null,
            cluster: null,
            keyWord: undefined,
            meterList: [],
            effecMeterList: [], // 经纬度信息不为空的有效信息
            dataSource: []
        }
    },
    created() {
        this.setDateTime()
    },
    mounted() {
        
        this.queryTotalCountByOrgCode()
        
        this.$nextTick(() => {
            this.initAMapByLoad();
        })
    },
    methods: {
        handleSearch(value) {

            this.loadData(value);
        },
        loadData(value) {
            console.log(value)
            let result = []
            for(let i = 0;i<this.effecMeterList.length;i++) {
                let item = this.effecMeterList[i]

                if((item.userName!==null&&item.userName.indexOf(value)>-1)||
                (item.userMeterAddr!==null&&item.userMeterAddr.indexOf(value)>-1)||
                (item.meterId!==null&&item.meterId.indexOf(value)>-1)||
                (item.userId!==null&&item.userId.indexOf(value)>-1)) {
                    result.push(item)
                }
            }
            this.dataSource = result
            console.log(this.dataSource)
        },
        handleChange(value) {
            console.log(value)
            if(isUndefined(value)) {
                this.dataSource = this.effecMeterList
                this.dealAMapMarkers(this.effecMeterList);
            }else{
                let map = this.map;
                let that = this
                // 根据点击的值在地图中显示该点信息
                let data = this.effecMeterList.filter(item => item.id === value.key)
                console.log(data)
                if(data.length>0) {
                    console.log(data)
                    this.amapConvertFrom([data[0].userMeterLng,data[0].userMeterLat]).then((resLnglat)=> {
                        map.setZoomAndCenter(17,resLnglat);
                        //markers[0].setAnimation('AMAP_ANIMATION_BOUNCE');
                        map.remove(markers)
                        that.addAMapMarker(resLnglat,data[0])
                    }).catch((e)=>{
                        console.error(e);
                    });
                }
            }
            
            //this.keyWord = value.userMeterAddr
        },
        setDateTime() {
            let time = formatTime(new Date().getTime(),'yyyy-MM-dd HH:mm:ss')
            let dateArr = time.split(' ')
            this.date = dateArr[0]
            this.time = dateArr[1]
        },
        queryTotalCountByOrgCode() {
            getAction(this.url.queryTotalCountByOrgCode,{}).then((res)=> {
                if(res.success) {
                    this.itemList[0].num = res.result.meterUserCount
                    this.itemList[1].num = res.result.meterUserCount
                }
            })
        },
        initAMapByLoad() {
            let that = this;
            AMapLoader.load({ //首次调用 load
                key:'05362cd4f6802209f097253d0d47b52b',//首次load key为必填
                version:'2.0',
                plugins:['AMap.Driving','AMap.Scale','AMap.Geocoder','AMap.ToolBar','AMap.ControlBar','AMap.DistrictSearch','AMap.MarkerCluster']
            }).then((AMap)=>{
                console.log('啦啦啦')
                that.map = new AMap.Map('container',{
                    viewMode: '3D', 
                    //center:[108.938411,34.339737],
                    resizeEnable: true,
                    rotateEnable:true,
                    pitchEnable:true,
                    zoom: 17,
                    pitch:30,
                    //rotation:-15,
                });
                that.map.on("complete", function(){
                    console.error("地图加载完成")
                    setTimeout(()=>{
                        that.queryMeterAddrInfoByOrgCode()
                    },5000)
                    
                    
                });
                let map = that.map;
                // 设置显示的要素,不显示标注point
                //map.setFeatures(['bg', 'road', 'building']);
                
                map.setMapStyle('amap://styles/8b9a8b2dc6a9a8e0727c158e743fa470');
                let controlBar = new AMap.ControlBar({
                    position: {
                        bottom: '80px',
                        right: '80px',
                    }
                });
                that.map.addControl(controlBar);
                
                /**
                    * 只显示陕西省的区域信息。其他地方的地图不展示
                    */
                /*
                new AMap.DistrictSearch({
                    extensions: 'all',
                    subdistrict: 0
                }).search('陕西省', function(status, result) {// 外多边形坐标数组和内多边形坐标数组
                    var outer = [
                        new AMap.LngLat(-360, 90, true),
                        new AMap.LngLat(-360, -90, true),
                        new AMap.LngLat(360, -90, true),
                        new AMap.LngLat(360, 90, true)
                    ]
                    var holes = result.districtList[0].boundaries
                    var pathArray = [outer]
                    pathArray.push.apply(pathArray, holes)
                    that.polygon = new AMap.Polygon({
                        pathL: pathArray,
                        strokeColor: 'red',//城市边界颜色
                        strokeWeight: 1,
                        fillColor: '#220986', // 遮罩背景色黑色
                        fillOpacity: 1
                    })
                    that.polygon.setPath(pathArray)
                    that.map.add(that.polygon)
                })
                */
            }).catch((e)=>{
                console.error(e);
            });
        },
        queryMeterAddrInfoByOrgCode() {
            this.meterList = []
            // 查看单位所安装表的坐标信息
            getAction(this.url.queryMeterAddrInfoByOrgCode,{}).then((res)=> {
                if(res.success) {
                    this.meterList = res.result
                    //this.meterList[0].userMeterLng = 108.971306
                    //this.meterList[0].userMeterLat = 34.187888
                    this.dealAMapMarkers(this.meterList);
                }
            })
        },
        async dealAMapMarkers(arrList) {
            let map = this.map;
            /*
            if(!isUndefinedAndNull(map.getAllOverlays())) {
                // 清除所有覆盖物
                map.clearMap();
            }
            */
            if(this.cluster!=null) {
                this.cluster.setMap(null)
            }
            let that = this
            let points = []
            await this.amapConvertFromBatch(arrList).then((result)=> {
                console.error("转换完成");
                let resLnglats = result.resLnglats
                let deptListNew = result.deptListNew
                for(let i = 0;i<resLnglats.length;i++) {
                    let resLnglat = resLnglats[i]
                    if(i == 0) {
                        // 默认将第一个点位设置为中心点
                        map.setZoomAndCenter(17,resLnglat);
                    }
                    that.addAMapMarker(resLnglat,deptListNew[i])
                    //points.push({lnglat: [resLnglat.lng+'',resLnglat.lat+'']});
                }
                console.error("点标记处理完成");
                
                map.add(markers);
            }).catch((e)=>{
                console.error(e);
            });
            console.log(points)
            //this.cluster = new AMap.MarkerCluster(map, points, {gridSize: 60});
        },
        amapConvertFrom(lnglat) {
            return new Promise(function(resolve,reject){
                AMap.convertFrom(lnglat, "baidu", function (status, result) {
                    if (result.info === 'ok') {
                        resolve(result.locations[0])
                    }else{
                        reject("转换出错")
                    }
                })
            })
        },
        amapConvertFromBatch(arrList) {
            let lnglats = []
            let deptListNew = arrList.filter(item => {
                return !isNull(item.userMeterLng)&&!isNull(item.userMeterLat)
            })
            for(let i = 0;i<deptListNew.length;i++) {
                let data = deptListNew[i]
                if(data.meterId == '00002119903558') {
                    console.error("怎么不显示那"+i+','+deptListNew.length)
                    console.log(!isNull(data.userMeterLng)&&!isNull(data.userMeterLat))
                    console.log(data)
                }
                lnglats.push(new AMap.LngLat(data.userMeterLng,data.userMeterLat))
            }
            console.log(deptListNew)
            this.effecMeterList = deptListNew
            this.dataSource = deptListNew
            return new Promise(function(resolve,reject){
                AMap.convertFrom(lnglats, "baidu", function (status, result) {
                    if (result.info === 'ok') {
                        // resolve只能处理一个参数
                        resolve({resLnglats:result.locations,deptListNew:deptListNew})
                    }else{
                        reject("转换出错")
                    }
                })
            })
        },
        addAMapMarker(resLnglat,data) {
            let map = this.map
            //let icon = this.setDeviceStatusIcon(data)
            let icon = ''
            let marker =  new AMap.Marker({
                icon: icon,
                position: resLnglat,
                anchor: 'top-center',
                label: {
                    content: `<div class='labelContent'>${data.userMeterAddr}</div>`,
                    //offset: new AMap.Pixel(0,-28)
                }
            });
            let that = this
            marker.on('click',function(e){that.queryMeterInfoByLngAndLat(data,resLnglat)});
            //map.add(marker);
            markers.push(marker)
            //return markers;
        },
        queryMeterInfoByLngAndLat(data,resLnglat) {
            console.log(data)
            getAction(this.url.queryMeterInfoByLngAndLat,{lng: data.userMeterLng,lat: data.userMeterLat}).then((res)=> {
                if(res.success) {
                    if(res.result.length>0) {
                        this.showInfoM(res.result,resLnglat)
                    }
                }
            })
        },
        showInfoM(meterArr,position){
            let map = this.map
            let deptPhoto = "";
            console.log(position)
            let str = '<div class="amapInfo">'
            str+=`<a-icon id="closeInfo${position.lat}" type="close-circle" class="closeInfo" >关闭</a-icon>`
            str+=`<table class="infoWindow">`
            str+='<tr><th>设备编号</th><th>用户姓名</th><th>联系电话</th><th>安装位置</th><th>阀门状态</th><th>运行状态</th></tr>'
            for(let i = 0;i<meterArr.length;i++) {
                let status = '正常'
                if(meterArr[i].meterBatteryStatus===1) {
                    status = '欠压'
                }
                if(meterArr[i].meterMagnetic===1) {
                    status+='有磁干扰'
                }
                let valveStatus= '开阀'
                if(!isUndefinedAndNull(meterArr[i].meterValveStatus)) {
                    valveStatus=Mn100FkStatusObj[meterArr[i].meterValveStatus]
                }
                str+=`<tr><td>${meterArr[i].meterId}</td><td>${meterArr[i].userName}</td><td>${meterArr[i].userPhone}</td><td>${meterArr[i].userMeterAddr}</td><td>${valveStatus}</td><td>${status}</td>`
                str+=`</tr>`
            }
            str+='</table></div>'
            var infoWindow = new AMap.InfoWindow({
                isCustom: true,  //使用自定义窗体
                content: str,
                //offset: new AMap.Pixel(16, -45)
            });
            infoWindow.open(map, position);
            setTimeout(() => {
            let that = this
            let closeInfoobj = document.getElementById('closeInfo'+position.lat);
            let meterObj = document.getElementById(position.lat);
            if(meterObj != null) {
                meterObj.onclick = function () {
                    //that.goIndex(params)
                }
            }
            closeInfoobj.onclick = function () {
                infoWindow.close()
            };
            },500)
        },
    }
}
</script>
<style lang="less" scoped>
.index-container{
    height: 100vh;
    background: url('~@/assets/images/bg.png') #08092D repeat;
    overflow: hidden;
}
.echarts {
    height: 100%;
}
.theme-color{
    color: #00FAFE;
}
.theme-color.theme-font{
    font-size: 30px;
    letter-spacing: -0.18px;
}
.header-row-line{
    background-image: linear-gradient(0deg, rgba(0,4,57,0.00) 0%, #00053A 100%);
}
.header{
    background: url('~@/assets/images/header.png') #000439 no-repeat;
    background-size: 100% 100%;
    padding-top: 7.3px;
    padding-bottom: 7.3px;
}
.ant-spin-nested-loading /deep/ .ant-spin-container{
    height: 100%
}
.tabs{
    display: flex;
    margin-left: 41px;
}
.tab{
    padding: 8px 16px;
    margin: 0 15px 0 0;
    
    cursor: pointer;
}
.tab-active{
    position: relative;
}
.tab-active::before{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #65CDE4;
    transition: all .3s;

}
.tab:last-child {

    margin-right: 0;
}
.tab-title{
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
}
.tab-active .tab-title{
    color: #6ED9F2;
    position: relative;
}
.header-right{
    margin-right: 27px;
    padding: 16px;
}
.right-time{
    color: #ffffff;
}
.right-time .time{
    font-size: 22px;
}
/* 每块内容的样式 */
.index-main{
    /deep/ .m-panel{
        color: #ffffff;
        height: 100%;
    }
}

</style>
<style>
    /*高德地图信息窗口样式开始 */
    .amap-info-contentContainer{
        width: 550px;
        background: rgba(0,0,0,0.7);
        border: 1px solid #32C5FF;
    }
    .amapInfo{
        color: #2BBDFB;
        padding: 20px;
        padding-top: 30px;
        background: linear-gradient(
            270deg
            ,#31D7FF,#31D7FF) 100% 0 no-repeat,linear-gradient(
            180deg
            ,#31D7FF,#31D7FF) 100% 0 no-repeat;
        background-size: 5px 18px,18px 5px;
        position: relative;
    }
    .amapInfo .closeInfo{
        position: absolute;
        cursor: pointer;
        top: 8px;
        right: 15px;
        color: #85A9DF;
        font-size: 14px;
    }
    .amapInfo .deptImg{
        border: 0.5px solid #2BBDFB;
        padding: 12px;
        position: relative;
    }
    .amapInfo .deptImg:after{
        position: absolute;
        content: '';
        left: -3px;
        right: -3px;
        top: -3px;
        bottom: -3px;
        background: linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 0 0 no-repeat,linear-gradient(
                180deg
                ,#31D7FF,#31D7FF) 0 0 no-repeat,linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 100% 0 no-repeat,linear-gradient(
                180deg
                ,#31D7FF,#31D7FF) 100% 0 no-repeat,linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 0 100% no-repeat,linear-gradient(
                180deg
                ,#31D7FF,#31D7FF) 0 100% no-repeat,linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 100% 100% no-repeat,linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 100% 100% no-repeat;
        background-size: 6px 6px,6px 6px,6px 6px,6px 6px;
    }
    .amapInfo a{
        color: #28E8FB;
        font-weight: 500;
    }
    .amapInfo a:hover{
        color: #00fbff!important;
    }
    .amapInfo .deptImg img:focus{
        outline: unset;
    }
    .amapInfo .infoWindow td,.amapInfo .infoWindow th{
        border-bottom: 1px solid #85A9DF;
        padding: 8px;
    }
    .amapInfo .infoWindow th{
        word-break: keep-all;
        white-space:nowrap;
        position: relative;
    }
    .amapInfo .infoWindow th:not(:first-child):before {
        position: absolute;
        content: "";
        left: 0;
        top: 8px;
        bottom: 0;
        width: 1px;
        margin: 3px 0;
        background: #9eb5ff;
    }
    .amapInfo .infoWindow th:not(:last-child):after {
        position: absolute;
        content: "";
        right: 0;
        top: 8px;
        bottom: 0;
        width: 1px;
        margin: 3px 0;
        background: #3e66e7;
    }
    .amap-marker-label{
        background :#041741;
        color: #31D7FF;
        border-radius: 3px;
        border: 1px solid #31D7FF;
    }
    /*高德地图信息窗口样式结束 */
    .keyWordSearh.ant-select-dropdown{
        background-color: rgba(2,31,95,0.8);
    }
    .keyWordSearh .ant-select-dropdown-menu-item{
        color: #fff;
    }
    .keyWordSearh .ant-select-dropdown-menu-item-selected{
        background-color: #021F5F;
    }
    .keyWordSearh .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){
        background-color: #021F5F;
        color: #85A9DF;
    }
    .keyWordSearh .ant-select-dropdown-menu-item-selected{
        color: #85A9DF;
    }
</style>